import React from "react";
import { Link } from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import CampaignList from "@/features/campaigns/shared/components/CampaignList";
import DigitalCampaignCard from "./DigitalCampaignCard";
import { CAMPAIGN_CONST } from "@/config/constants";
import { BRAND_CONST } from "@/config/constants";
import type {
  DigitalCampaignBrand,
  DigitalCampaignCardData,
} from "./digitalCampaignTypes";

type DigitalCampaignListProps = {
  selectedBrand?: DigitalCampaignBrand;
  isThereAnyActiveSubscription?: boolean;
  campaigns?: DigitalCampaignCardData[];
  isLoading?: boolean;
  searchValue?: string;
  participantId?: string | number;
};

const isJoinWindowPending = (campaign: DigitalCampaignCardData) => {
  const { availability_window, availability_window_date } = campaign;
  if (!availability_window) return false;
  if (
    availability_window ===
    CAMPAIGN_CONST.AVAILABILITY_WINDOW.TYPE.ALWAYS_AVAILABLE
  )
    return false;
  return availability_window_date?.last_day_to_join;
};

const SubscriptionPrompt = () => (
  <h6 className="link my-5 d-flex align-items-md-center">
    <InfoOutlinedIcon className="mr-2" />
    <Link to="/subscription-packages">
      Subscribe now to launch brand ad campaigns for your restaurant(s).
    </Link>
  </h6>
);

const DigitalCampaignList = ({
  selectedBrand,
  isThereAnyActiveSubscription,
  campaigns = [],
  isLoading,
  searchValue = "",
  participantId,
}: DigitalCampaignListProps) => {
  const showSubscriptionPrompt =
    selectedBrand?.id === BRAND_CONST.JINYA_RAMEN_BAR_BRAND_ID &&
    !isThereAnyActiveSubscription &&
    selectedBrand?.has_active_subscription_page;

  return (
    <div className="yet-to-join-campaigns">
      {showSubscriptionPrompt ? (
        <SubscriptionPrompt />
      ) : (
        <CampaignList
          campaigns={campaigns}
          isLoading={isLoading}
          searchValue={searchValue}
          emptyMessage="No campaigns are currently available."
          renderCard={(campaign) => (
            <DigitalCampaignCard
              campaign={campaign}
              isJoinWindowPending={isJoinWindowPending(campaign)}
              participantId={participantId}
            />
          )}
        />
      )}
    </div>
  );
};

export default DigitalCampaignList;
